import React from 'react'

const TONES = {
  live: { pill: 'bg-[#e8f6ef] text-[#1f7a55]', dot: 'bg-[#2fb597]' },
  draft: { pill: 'bg-[#fdf3dc] text-[#8a5a00]', dot: 'bg-[#e0a526]' },
}

// A card's sale status: live (Active, Published) in green, not yet sellable (Draft) in amber.
export function StatusPill({ label, tone = 'live' }) {
  const { pill, dot } = TONES[tone] || TONES.live
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[13px] font-semibold ${pill}`}>
      <span aria-hidden={true} className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      {label}
    </span>
  )
}
